import ApiService from '../../services/ApiService.js';

export const namespaced = true;

export const state = {
	courses: []
};

export const mutations = {
};

export const actions = {
	// eslint-disable-next-line
	add({commit}, data) {
		return ApiService.addRound(data);
	},
	// eslint-disable-next-line
	edit({commit}, data) {
		return ApiService.editRound(data);
	},
	getAll() {
		return ApiService.getRounds();
	},
	getStatsRounds() {
		return ApiService.getStatsRounds();
	},
	getShotAnalysis() {
		return ApiService.getShotAnalysis();
	},
	
	// eslint-disable-next-line
	getRound({commit}, uuid) {
		return ApiService.getRound(uuid);
	},
};

export const getters = {};
